import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _username = signal<string | null>(null);
  private readonly _useremail = signal<string | null>(null);

  // Public readonly signal for components to consume
  readonly username = computed(() => this._username());
  readonly useremail = computed(() => this._useremail());

  roles = signal<string[]>([]);

  setUser(name: string, email: string) {
    this._username.set(name);
    this._useremail.set(email);
  }

  setRoles(roles: string[]) {
    this.roles.set(roles);
  }

  getUserName(): string | null {
    let userFromJson: string | null = sessionStorage.getItem('userInfo');
    if (userFromJson == null) {
      return this.username();
    }
    return JSON.parse(userFromJson ?? '');
  }

  getUserEmail(): string | null {
    let userFromJson: string | null = sessionStorage.getItem('userInfo');
    if (userFromJson == null) {
      return this.useremail();
    }
    return JSON.parse(userFromJson ?? '');
  }
}
